<script lang="ts">
	import type { DateRange as DateRangeType } from 'utility/search-fields'
	import type { ComponentProps } from 'svelte'

	import DateRange from '@isoftdata/svelte-date-range'
	import Pin from 'components/search/Pin.svelte'

	interface Props extends ComponentProps<typeof DateRange> {
		label?: string
		disabled?: boolean
		isPinned?: boolean
		dates?: DateRangeType
		id?: string
	}

	let {
		label = '',
		disabled = false,
		isPinned = false,
		dates = $bindable({ from: '', to: '' }),
		id = '',
		...rest
	}: Props = $props()
</script>

<label
	for={id}
	class="col-form-label pb-0"
	>{label}
	<Pin {isPinned} />
</label>

<DateRange
	{...rest}
	fromId={id}
	allowNone
	colClass="col-12 col-lg-6"
	hideDateRange
	bind:dates
	{disabled}
/>
